import { BaseUnits } from "uom";
import * as UnitDivide from "../unit-divide";
import { KiloWatt } from "./power";
import { Celsius } from "./temperature";
// Heat Capacity Rate
export var KilowattPerCelsius = UnitDivide.powerByTemperature("KilowattPerCelsius", KiloWatt, Celsius);
export var KilowattPerKelvin = UnitDivide.powerByTemperature("KilowattPerKelvin", KiloWatt, BaseUnits.Kelvin);
//# sourceMappingURL=heat-capacity-rate.js.map